/// <reference path="./palette-mixin.d.ts"/>
import { PaletteOptions } from '@mui/material/styles/createPalette';
// import { grey, amber, teal } from '@mui/material/colors'

const getPaletteMixin = (mode: 'light' | 'dark'): PaletteOptions => ({
  mode,
  primary: {
    main: '#122B49',
    light1: '#2A5484',
  },

  warning: {
    main: '#E29A1C',
    contrastText: '#FFF',
  },

  moss: {
    main: '#8BAE46',
    light2: '#D7F3A2',
    light1: '#B1D272',
    dark1: '#708541',
    dark2: '#515A3D',
  },
  daisy: {
    main: '#FEC91B',
    light1: '#FFE17A',
    dark1: '#EDB200',
    dark2: '#C98F00',
  },
  rust: {
    main: '#E96115',
    light1: '#FF8F51',
    light2: '#FFC599',
    dark1: '#B24501',
  },
  coral: {
    main: '#FF5662',
    light2: '#FFB6B9',
    light1: '#FF848A',
    dark1: '#C81326',
  },
  // primary:
  //   mode === 'light'
  //     ? {
  //         dark2: teal[800],
  //         dark1: teal[700],
  //         main: teal[500],
  //         light1: teal[300],
  //         light2: teal[200],
  //         light3: teal[100],
  //         light4: teal[50],
  //       }
  //     : {
  //         dark2: teal[50],
  //         dark1: teal[50],
  //         dark: teal[100],
  //         main: teal[200],
  //         light: teal[300],
  //         light1: teal[400],
  //         light2: teal[500],
  //         light3: teal[600],
  //         light4: teal[800],
  //       },
  // secondary:
  //   mode === 'light'
  //     ? {
  //         dark2: amber[800],
  //         dark1: amber[700],
  //         main: amber[500],
  //         light1: amber[300],
  //         light2: amber[200],
  //         light3: amber[100],
  //       }
  //     : {
  //         dark2: amber[100],
  //         dark1: amber[200],
  //         dark: amber[300],
  //         main: amber[400],
  //         light: amber[500],
  //         light1: amber[600],
  //         light2: amber[700],
  //         light3: amber[800],
  //       },
  // success:
  //   mode === 'light'
  //     ? {
  //         dark: '#60a405',
  //         main: '#68b500',
  //         light: '#def4dc',
  //       }
  //     : {
  //         dark: '#def4dc',
  //         main: '#68b500',
  //         light: '#60a405',
  //       },
  // info:
  //   mode === 'light'
  //     ? {
  //         dark: '#01579b',
  //         main: '#0288d1',
  //         light: '#71d3fe',
  //       }
  //     : {
  //         dark: '#71d3fe',
  //         main: '#0288d1',
  //         light: '#01579b',
  //       },
  // warning:
  //   mode === 'light'
  //     ? {
  //         dark: '#e0910f',
  //         main: '#f2a019',
  //         light: '#fcf0d1',
  //       }
  //     : {
  //         dark: '#fcf0d1',
  //         main: '#f2a019',
  //         light: '#e0910f',
  //       },
  // error:
  //   mode === 'light'
  //     ? {
  //         dark: '#be2b28',
  //         main: '#c30f1c',
  //         light: '#ffebeb',
  //       }
  //     : {
  //         dark: '#ffebeb',
  //         main: '#fa9aa0',
  //         light: '#be2b28',
  //       },
  // ...(mode === 'dark' && {
  //   background: {
  //     default: grey[900],
  //     paper: grey[800],
  //   },
  // }),
});

export default getPaletteMixin;
